var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('p',{staticClass:"title flex-grow-1"},[_vm._v(_vm._s(_vm.item.name))]),_c('div',{staticClass:"favorite"},[_c('Favorite',{attrs:{"item":_vm.item}}),_c('p',[_vm._v(_vm._s(_vm._f("numberWithCommas")(_vm.item.no_favorite))+" คน")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }